import { render, staticRenderFns } from "./expressFastRoute.vue?vue&type=template&id=602b56d8&scoped=true"
import script from "./expressFastRoute.vue?vue&type=script&lang=js"
export * from "./expressFastRoute.vue?vue&type=script&lang=js"
import style0 from "./expressFastRoute.vue?vue&type=style&index=0&id=602b56d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602b56d8",
  null
  
)

export default component.exports